const message = {
    toptips: "防篡改，可追溯，公开透明",
    traning_code: "溯源码",
    scantimes: '扫码次数',
    productinfo: '产品信息',
    batch_no: '批次号',
    product_name: '产品名称',
    blockchain_ident: '交易hash',
    not_support_video: '你的手机浏览器内核不支持video标签',
    blockchain_verify: '区块链查验',
    pass: '验证通过',
    blockchian: "区块链",
    hxchain: '海星链',
    height: '区块高度',
    evidence_time: '存证时间',
    signature: '数字签名',
    txhash: '交易hash',
    pass_content: '数据已在区块链加密存证，未被篡改！',
    inputCheckCode: '请输入6位溯源验证码',
    input_code: '请输入6位溯源验证码',
    query: "查询",
    queryTitle: "溯源验真查询",
    inputTip1: "请输入溯源验证码",
    errCheckCode: "抱歉，您输入的验证码无效，请核对后再次输入",
    tooManyQuery: "查询错误次数过多，请稍后重试",
    tips2: "一物一码，区块链溯源，全球品质保障！",
    goodsInfo: "商品信息",



    // 保修相关翻译
    warranty_application: '保修申请',
    product_info: '产品信息',
    warranty_status: '保修状态',
    warranty_valid: '在保修期内',
    warranty_expired: '已过保修期',
    application_info: '申请信息',
    applicant_name: '申请人',
    please_input_name: '请输入申请人姓名',
    name_required: '请输入申请人姓名',
    contact_info: '联系方式',
    please_input_contact: '请输入联系方式',
    contact_required: '请输入联系方式',
    feedback_content: '反馈内容',
    please_input_feedback: '请描述您遇到的问题',
    feedback_required: '请输入反馈内容',
    submit_application: '提交申请',
    application_submitted_success: '申请提交成功',
    processing_progress: '处理进度',
    application_submitted: '申请已提交',
    application_submitted_desc: '您的保修申请已成功提交',
    under_review: '审核中',
    under_review_desc: '我们的工作人员正在审核您的申请',
    start_time: '开始时间',
    history_records: '历史记录',
    no_history_records: '暂无历史记录',
    processing_result: '处理结果',
    reason: '原因',
    status_submitted: '已提交',
    status_processing: '处理中',
    status_processed: '已处理',
    status_unknown: '未知状态',
    load_history_failed: '加载历史记录失败',
    warranty_tips: '尚有待处理的申请，等待完成后才能继续申请。',
    feed_ask: '期望结果',
    status_failed: '处理失败',

}
module.exports = message